u.AutoCompleteOption = class extends u.BaseElement {
    /**
     * 
     */
    createdCallback() {
        /**
         * 
         */
        super.createdCallback();

        this.style.display = 'block';
        this.style.overflowX =  'hidden';
        this.style.textOverflow = 'ellipsis';
        this.style.whiteSpace = 'nowrap';

        this.$parent = null;
        this.$value = null;
        
        this._mouseEnter = (evt) => {
            /**
             * When mouse event is fired, make sure it was the primary mouse button
             */
            if (evt.button === 0) {
                const highlighted = this.$parent.$highlighted();
                if (highlighted) {
                    highlighted.classList.remove(this.$parent.$highlightClass);
                }
                this.classList.add(this.$parent.$highlightClass);
            } else {
                evt.preventDefault();
            }
        };
    }
    
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('mouseenter', this._mouseEnter);         
    }

    detachedCallback() {
        /**
         *
         */
        super.detachedCallback();        
        this.removeEventListener('mouseenter', this._mouseEnter);        
    }
};

u.AutoCompleteOption.register('u-autocomplete-option');
